import styled from 'styled-components';
import { breakpoints, css } from 'src/styles/theme';
import { Pages } from 'src/types/pages';
import { SummaryDealerDetailsStyled } from '../SummaryDealerDetailsStyled';
import { rem } from 'polished';

export const SummaryDealerDetailsOV = styled(SummaryDealerDetailsStyled)`
    border-bottom: ${rem('1px')} solid black;
    border-top: ${rem('1px')} solid black;

    .totalPriceWrapper {
        @media (max-width: ${breakpoints.md}px) {
            display: flex;

            .totalPrice {
                padding-top: unset !important;
                display: flex;
                flex-direction: column;
                align-items: flex-end;
            }
        }
    }
    .titleWrapper {
        .isClose {
            svg {
                path {
                    fill: ${({ theme }) => theme.colors.black};
                }
            }
        }
        .isOpen {
            svg {
                path {
                    stroke: ${({ theme }) => theme.colors.black};
                }
            }
        }
    }

    .titleWrapper {
        .title {
            text-transform: capitalize;
            font-size: ${rem(22)};
        }
    }

    .Collapsible__contentInner {
        .container {
            .info {
                .infoIcon {
                    svg {
                        circle {
                            fill: ${({ theme }) => theme.colors.black};
                            stroke: white;
                        }
                        path {
                            fill: white;
                        }
                    }
                }
            }
        }
    }

    .linkButton {
        border: unset;
        text-align: left;
        padding: unset;
        font-weight: bold;
        font-size: ${rem('16px')};
        margin-top: ${rem('16px')};
        color: ${({ theme }) => theme.colors.black};
        background: unset;
        cursor: pointer;
        width: fit-content;
        position: relative;
        display: flex;
        flex-direction: row-reverse;

        .txt {
            margin-left: ${rem('7px')};
        }

        .icon-wrapper {
            svg path {
                fill: black !important;
                stroke: black !important;
            }
        }

        &:hover {
            &:after {
                content: '';
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 1px;
                background-color: ${({ theme }) => theme.colors.black};
            }

            .icon-wrapper {
                svg path {
                    fill: ${({ theme }) => theme.colors.black} !important;
                    stroke: ${({ theme }) => theme.colors.black} !important;
                }
            }
        }
    }
`;
